// extracted by mini-css-extract-plugin
export default {"menu":"Nav_menu__k4-HU","dropdown":"Nav_dropdown__pNreV","hiddenLang":"Nav_hiddenLang__FT1B5","dropdownLang":"Nav_dropdownLang__9eMYW"};